import { BookFormat } from './book-format.type';

export enum STKey {
  id,
  original,
  sizeType,
  boxes,
  features,
  orientations,
  tempData,
}

export enum STBoxKey {
  left,
  top,
  width,
  height,
  orientation,
}

export enum CollageSizesKeys {
  full = 1,
  half = 2,
}

export enum TemplateFeatures {
  gaps,
  scaleDown,
  flipX,
  flipY,
  flipXY,
  /** Второй, более крупный отступ: вариант `+scale:0.7` от исходника (панорама). */
  scaleDownLarge,
}

type Id = string;

type Left = number;

type Top = number;

type Width = number;

type Height = number;

export type TemplateOriginalImageSizes = [Width, Height];

export type CollageSize = CollageSizesKeys;

export type Orientation = 'h' | 'v' | 'r';

export type OrientationsString = string;

export type SimplifiedBox = [Left, Top, Width, Height, Orientation];

export interface SimplifiedTemplateTempData {
  isUserTemplate?: boolean;
  userTemplateId?: number;
}

export type Template = [
  Id,
  TemplateOriginalImageSizes, // original sizes of collage template image
  CollageSize,
  SimplifiedBox[],
  TemplateFeatures[], // transform features
  OrientationsString,
  SimplifiedTemplateTempData?,
];

export function isTemplate(data: unknown): data is Template {
  return Array.isArray(data) && typeof data[0] === 'string';
}

export interface SpreadTemplates {
  [key: number]: {
    // vertical boxes count
    [key: number]: {
      // horizontal boxes count
      [key: number]: /* rect boxes count */ Template[];
    };
  };
}

export type TemplatesByFormat = { [key in BookFormat]: SpreadTemplates };

export type CollageTemplate = {
  id: number;
  template_id: string;
  container: TemplateOriginalImageSizes; // original sizes of collage template image
  boxes: LAlign[];
  size: CollageSize;
  prms: {
    format: BookFormat;
  };
};

export type LAlign = {
  top: number;
  left: number;
  width: number;
  height: number;
};
